import apiSlice from "../api/apiSlice";
import { setActiveProjects } from "./projectSlice";

const projectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjects: builder.query({
      query: () => "/projects",
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const { data } = await queryFulfilled;
        const formatedData = data.map((p) => p.projectName);
        dispatch(setActiveProjects(formatedData));
      },
    }),
    getSingleProject: builder.query({
      query: (name) => `/projects?projectName=${name}`,
    }),
  }),
});

export const { useGetProjectsQuery, useGetSingleProjectQuery } = projectsApi;
